import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import ErrorPage from '../../components/errorPage/ErrorPage';
import { notAuthorizedIcon } from '../../public/assets/icons';

const UnauthorizedUser = (): JSX.Element => {
    const { t } = useTranslation();
    const history = useHistory();

    return (
        <ErrorPage
            icon={notAuthorizedIcon}
            header= {t('errors.unauthorized.description')}
            description= {t('errors.unauthorized.nextSteps')}
            buttonTitle={t('buttonName.backToHome')}
            onButtonClick={() => history.push('/')}
        />
    );
};

export default UnauthorizedUser;
